var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('p',{staticClass:"text_xs color_neutral_400"},[_vm._v(" @ 2023, Made by "),_c('a',{staticClass:"color_brand_500 semibold",attrs:{"href":"#","target":"_blank"}},[_vm._v("Card Security")]),_vm._v(" & "),_c('a',{staticClass:"color_brand_500 semibold",attrs:{"href":"https://rednosed.agency/","target":"_blank"}},[_vm._v("RND")])])])
}]

export { render, staticRenderFns }